<template>
  <div class="animated fadeIn liquidacion-sueldos">
    <b-row>
      <b-col xl="12">
        <b-form>
          <b-card header="Liquidación de Sueldos">
            <b-form-group
              label="Periodo"
              label-for="periodo"
              :labelCols="labelCols"
              horizontal>
              <b-form-input 
                id="periodo" 
                v-model="periodoLiquidacion" 
                type="text"
                readonly>
              </b-form-input>
            </b-form-group>
          </b-card>

          <b-card>
            <b-table 
                small 
                responsive="sm"
                class="registro" 
                :items="liquidacionesPersonal" 
                :fields="fields">
              <template v-slot:cell(honorarios)="data">
                <template v-if="data.item.readOnly">
                  {{  data.item.honorarios }}
                  <!-- <input
                    class="disabled" 
                    :value="data.item.honorarios"
                    readonly/> -->
                </template>
                <template v-if="!data.item.readOnly">
                  <input type="number"
                      v-model.number="data.item.honorarios"
                      @focus="$event.target.select()"
                      @input="actualizarTotales(data.item)"/>
                </template>
              </template>
              <template v-slot:cell(adicional)="data">
                <template v-if="data.item.readOnly">
                  {{ data.item.adicional }}
                  <!-- <input
                    class="disabled" 
                    :value="data.item.adicional"
                    readonly/> -->
                </template>
                <template v-if="!data.item.readOnly">
                  <input type="number"
                      v-model.number="data.item.adicional"
                      @focus="$event.target.select()"
                      @input="actualizarTotales(data.item)"/>
                </template>
              </template>
              <template v-slot:cell(otrosConceptos)="data">
                <template v-if="data.item.readOnly">
                  {{ data.item.otrosConceptos }}
                  <!-- <input
                    class="disabled" 
                    :value="data.item.otrosConceptos"
                    readonly/> -->
                </template>
                <template v-if="!data.item.readOnly">
                  <input type="number"
                      v-model.number="data.item.otrosConceptos"
                      @focus="$event.target.select()"
                      @input="actualizarTotales(data.item)"/>
                </template>
              </template>
              <template v-slot:cell(liquidacionFinal)="data">
                <template v-if="data.item.readOnly">
                  {{ data.item.liquidacionFinal }}
                  <!-- <input
                    class="disabled" 
                    :value="data.item.liquidacionFinal"
                    readonly/> -->
                </template>
                <template v-if="!data.item.readOnly">
                  <input type="number"
                      v-model.number="data.item.liquidacionFinal"
                      @focus="$event.target.select()"
                      @input="actualizarTotales(data.item)"/>
                </template>
              </template>
              <template v-slot:cell(total)="data">
                {{ data.item.total | moneda }}
              </template>
            </b-table>

            <b-table 
                small 
                responsive="sm"
                class="registro totales" 
                :items="totales" 
                :fields="totalesFields">
              <template v-slot:cell(honorarios)="data">
                {{ data.item.honorarios | moneda }}
              </template>
              <template v-slot:cell(adicional)="data">
                {{ data.item.adicional | moneda }}
              </template>
              <template v-slot:cell(otrosConceptos)="data">
                {{ data.item.otrosConceptos | moneda }}
              </template>
              <template v-slot:cell(liquidacionFinal)="data">
                {{ data.item.liquidacionFinal | moneda }}
              </template>
              <template v-slot:cell(adelantos)="data">
                {{ data.item.adelantos | moneda }}
              </template>
              <template v-slot:cell(total)="data">
                {{ data.item.total | moneda }}
              </template>
            </b-table>
          </b-card>
        </b-form>
      </b-col>
    </b-row>

    <app-a-b-m-button
      @save="save"
      @cancel="goList">
    </app-a-b-m-button>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import ABMButtons from '../shared/abmButtons.vue';
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'liquidacionSueldos/getField',
  mutationType: 'liquidacionSueldos/updateField',
});

export default {
  name: 'ABM',
  components: {
    appABMButton: ABMButtons,
    appMensaje: Mensaje
  },
  mixins: [ 
    msjModal, 
  ],
  data () {
    return {
      labelCols: 1,

      fields: [
        { key: 'personal' },
        {
          key: 'honorarios',
          label: 'Sueldo',
          class: 'text-right'
        },
        {
          key: 'adicional',
          class: 'text-right'
        },
        {
          key: 'otrosConceptos',
          label: 'Otros Conceptos',
          class: 'text-right'
        },
        {
          key: 'liquidacionFinal',
          label: 'Liq. Final',
          class: 'text-right'
        },
        {
          key: 'adelantos',
          label: 'Adelantos',
          class: 'text-right'
        },     
        {
          key: 'total',
          label: 'Total',
          class: 'text-right'
        },     
      ],

      totalesFields: [
        { key: 'totales' },
        {
          key: 'honorarios',
          label: 'Sueldo',
          class: 'text-right'
        },
        {
          key: 'adicional',
          class: 'text-right'
        },
        {
          key: 'otrosConceptos',
          class: 'text-right'
        },
        {
          key: 'liquidacionFinal',
          class: 'text-right'
        },
        {
          key: 'adelantos',
          class: 'text-right'
        },
        {
          key: 'total',
          class: 'text-right'
        },
      ],
    }
  },
  computed: {
    ...mapFields([
      'periodoMesNombre',
      'periodoAnio',
      'sac',
      'liquidacionesPersonal',
      'totalLiquidacion',
      'totales',
      'observaciones'
    ]),
    periodoLiquidacion() {
      return this.periodoMesNombre.trim() 
        + ' ' 
        + parseInt(this.periodoAnio).toString().trim() 
        + (((/true/i).test(this.sac))? ' - SAC': '') ;
    },
  },
  created() {
    let liquidacionSueldosId = 0;
    if (this.$route.params){
      if (this.$route.params.id){
        liquidacionSueldosId = this.$route.params.id;
      }
    }

    this.showSpinner();
    this.$store.dispatch('liquidacionSueldos/getLiquidacionSueldos', liquidacionSueldosId)
      .catch(error => this.showErrorMsj(error))
      .finally(() => this.hideSpinner());
  },  
  activated() {
  },
  methods: {
    actualizarTotales() {
      this.$store.dispatch('liquidacionSueldos/calcularTotales');
    },
    save() {
      this.showSpinner();
      this.$store.dispatch('liquidacionSueldos/save')
        .then( () => this.showModalMsj ('Los cambios se registraron con éxito.', this.goList, this.goList, 'light'))
        .catch( error => this.showErrorMsj (error))
        .finally(() => this.hideSpinner());
    },
    goList() {
      this.$router.push({ name: 'LiquidacionesSueldos' }); 
    }
  },
  validations: {
  },  
  watch: {
  },
}
</script>

<style>
  .liquidacion-sueldos .registro table td {
    vertical-align: middle;
    border: none;
  }
  .liquidacion-sueldos .registro table td[aria-colindex="1"] {
    width: 40%;
  }
  .liquidacion-sueldos .registro table td[aria-colindex="2"] {
    width: 10%;
  }
  .liquidacion-sueldos .registro table td[aria-colindex="3"] {
    width: 10%;
  }
  .liquidacion-sueldos .registro table td[aria-colindex="4"] {
    width: 10%;
  }
  .liquidacion-sueldos .registro table td[aria-colindex="5"] {
    width: 10%;
  }
  .liquidacion-sueldos .registro table td[aria-colindex="6"] {
    width: 10%;
  }
  .liquidacion-sueldos .registro table td[aria-colindex="7"] {
    width: 10%;
  }

  .liquidacion-sueldos .registro.totales table thead {
    display: none;
  }
  .liquidacion-sueldos .registro.totales table tr td {
    border-top: none;
    font-weight: bold;
  }

  .liquidacion-sueldos .registro table td input.disabled {
    color: rgba(35, 40, 44, 0.7);
    border-bottom: 1px solid lightgray;
  }  
</style>
